/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_TranscriptionInputs */

const en_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.10 / min`)
};

const fr_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,10 $ / min`)
};

const de_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,10 $ / Minute`)
};

const it_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0,10 / min`)
};

const ru_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,10 долл. США/мин`)
};

const es_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.10 / minuto`)
};

const zh_cn2_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟 0.10 美元`)
};

const ja_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.10ドル / 分`)
};

const hi_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.10 / मिनट`)
};

const pt_pt2_usage_rate_transcription = /** @type {(inputs: Usage_Rate_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$ 0,10 / min`)
};

/**
* | output |
* | --- |
* | "$0.10 / min" |
*
* @param {Usage_Rate_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_transcription = /** @type {((inputs?: Usage_Rate_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_rate_transcription(inputs)
	if (locale === "de") return de_usage_rate_transcription(inputs)
	if (locale === "it") return it_usage_rate_transcription(inputs)
	if (locale === "ru") return ru_usage_rate_transcription(inputs)
	if (locale === "es") return es_usage_rate_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_rate_transcription(inputs)
	if (locale === "ja") return ja_usage_rate_transcription(inputs)
	if (locale === "hi") return hi_usage_rate_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_rate_transcription(inputs)
	return en_usage_rate_transcription(inputs)
});